import { jsx as f } from "react/jsx-runtime";
import { PaddingSize as S } from "../../../utils/enums.js";
import { composeIDSCard as C } from "../helpers/composeIDSCard.js";
import { composeIDSCardSlots as I } from "../helpers/composeIDSCardSlots.js";
const b = ({
  className: r,
  padding: t = S.Md,
  selected: s,
  stretch: a,
  children: d,
  footer: e,
  heading: i,
  media: m,
  prepend: p,
  topRight: c,
  ...o
}) => {
  const n = C({
    className: r,
    clickable: !0,
    padding: t,
    selected: s,
    stretch: a
  }), l = I({
    children: d,
    "data-testid": o["data-testid"],
    footer: e,
    heading: i,
    media: m,
    prepend: p,
    topRight: c
  });
  return /* @__PURE__ */ f("a", { ...o, ...n, children: l });
};
export {
  b as IressLinkCard
};
